
  class AddImagePlanOverlay extends google.maps.OverlayView {
    bounds;
    image;
    div;
    img;
    imageId;
    width;
    height;
    offsetX;
    offsetY;
    rotation;
    opacity;
    constructor(map, image, id, width, height, offsetside, offsettop, rotation) {
      super();
      this.bounds = map.getBounds();
      this.image = image;
      this.imageId = id;
      this.width = width;
      this.height = height;
      this.offsetX = offsetside;
      this.offsetY = offsettop;
      this.rotation = rotation;
    }
    /**
     * onAdd is called when the map's panes are ready and the overlay has been
     * added to the map.
     */
    onAdd() {
      this.div = document.createElement("div");
      this.div.style.borderStyle = "none";
      this.div.style.borderWidth = "0px";
      this.div.style.position = "absolute";
      this.div.style.transform = 'rotate(' + this.rotation + 'deg)';
      this.div.style.left =  this.offsetX + 'px';
      this.div.style.top =  this.offsetY + 'px';

      // Create the img element and attach it to the div.
      this.img = document.createElement("img");

      this.img.style.position = "absolute";
      this.img.id = this.imageId;
      this.div.appendChild(this.img);

      this.hide();
      // Add the element to the "overlayLayer" pane.
      const panes = this.getPanes();

      panes.overlayLayer.appendChild(this.div);
    }
    draw() {
      // We use the south-west and north-east
      // coordinates of the overlay to peg it to the correct position and size.
      // To do this, we need to retrieve the projection from the overlay.
      const overlayProjection = this.getProjection();
      // Retrieve the south-west and north-east coordinates of this overlay
      // in LatLngs and convert them to pixel coordinates.
      // We'll use these coordinates to resize the div.
      var bounds = this.map.getBounds();
      const sw = overlayProjection.fromLatLngToDivPixel(
        bounds.getSouthWest()
      );
      const ne = overlayProjection.fromLatLngToDivPixel(
        bounds.getNorthEast()
      );
      
      // Resize the image's div to fit the indicated dimensions.
      if (this.div) {
        let newOffsetX = parseFloat(sw.x) + parseFloat(this.offsetX);
        let newOffsetY = parseFloat(ne.y) + parseFloat(this.offsetY);
        this.div.style.left = newOffsetX + "px";
        this.div.style.top = newOffsetY + "px";
        this.div.style.width = this.width + "px";
        this.div.style.height = this.height + "px";
      }
    }
    /**
     * The onRemove() method will be called automatically from the API if
     * we ever set the overlay's map property to 'null'.
     */
    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        delete this.div;
      }
    }
    /**
     *  Set the visibility to 'hidden' or 'visible'.
     */
    hide() {
      if (this.div) {
        this.div.style.visibility = "hidden";
      }
    }
    show() {
      if (this.div) {
        this.div.style.visibility = "visible";
      }
    }
    updateImage(src) {
      const that = this.img;
      return new Promise((resolve, reject) => {
        that.src=src;
        setTimeout(() => resolve("Ok"),100);
        //return that.width, that.height;
      });
    }
    updateSize(newWidth, newHeight) {
        this.width = newWidth;
        this.height = newHeight;
        this.img.style.width = newWidth +"px";
        this.img.style.height = newHeight +"px";
        this.draw();
        return new Promise((resolve, reject) => {
          setTimeout(() => resolve("Ok"),100);
        });
    }
    applyRotation(newVal) {
      this.div.style.transform = 'rotate(' + newVal + 'deg)';
      return new Promise((resolve, reject) => {
        setTimeout(() => resolve("Ok"),10);
      });
    }
    updateOffsetX(newVal) {
      this.offsetX = newVal;
      this.draw();
      return new Promise((resolve, reject) => {
        setTimeout(() => resolve("Ok"),100);
      });
    }
    updateOffsetY(newVal) {
      this.offsetY = newVal;
      this.draw();
      return new Promise((resolve, reject) => {
        setTimeout(() => resolve("Ok"),100);
      });
    }
    updateTransparency(newVal) {
      this.img.style.opacity=newVal;
    }
    updateVisibility() {
      if(this.div && this.img && this.img.src != "" && this.img.src != window.location.href) {
        this.show();
      } else {
        this.hide();
      }
    }
    getSouthWestPos() {
        var overlayProjection = this.getProjection();
        
        var bounds = this.map.getBounds();
        const sw = overlayProjection.fromLatLngToDivPixel(
        bounds.getSouthWest()
        );
        const ne = overlayProjection.fromLatLngToDivPixel(
        bounds.getNorthEast()
        );

        var x = parseInt(this.offsetX)+parseInt(sw.x);
        var y =  parseInt(this.offsetY) + parseFloat(this.height)+ parseInt(ne.y); // on prend northeast.y car on veut décale a partir du haut
        return overlayProjection.fromDivPixelToLatLng({x: x,y: y});
    }
    getNorthEastPos() {
        var overlayProjection = this.getProjection();
        
        var bounds = this.map.getBounds();
        const sw = overlayProjection.fromLatLngToDivPixel(
        bounds.getSouthWest()
        );
        const ne = overlayProjection.fromLatLngToDivPixel(
        bounds.getNorthEast()
        );

        var x = parseInt(this.offsetX) + parseFloat(this.width) +parseInt(sw.x);// on prend southwest.x car on veut décale a partir du coté
        var y =  parseInt(this.offsetY) + parseInt(ne.y); 
        return overlayProjection.fromDivPixelToLatLng({x: x,y: y});
    }
  }

  export default AddImagePlanOverlay;